import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import * as historicalAPI from "../../api/historical";

const initialState = {
  loading: false,

  attendance: {
    data: null,
    totalNo: {
      totalNoOfRecords: 0,
    },
  },
  marks: {
    data: null,
  },
};

const getHistoricalAttendance = createAsyncThunk(
  "historical/getHistoricalAttendance",
  async (params, { rejectWithValue }) => {
    try {
      const res = await historicalAPI.getHistoricalAttendance(params);
      if (res.data.statusCodeValue >= 400) {
        // alert();
        return rejectWithValue(res.data.body.error);
      }
      //console.log("getStudentHistorical", res.data.body);
      return res.data.body;
    } catch (error) {
      // alert("catch");
      return rejectWithValue(error);
    }
  }
);

const getHistoricalMarks = createAsyncThunk(
  "historical/getHistoricalMarks",
  async (params, { rejectWithValue }) => {
    try {
      const res = await historicalAPI.getHistoricalMarks(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data.body;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const historicalSlice = createSlice({
  name: "historical",
  initialState,
  reducers: {
    resetState: () => {
      return initialState;
    },
    resetAttendance: (state, action) => {
      state.attendance = initialState.attendance;
    },

    resetMarks: (state, action) => {
      state.marks = initialState.marks;
    },
  },
  extraReducers: {
    [getHistoricalAttendance.pending]: (state) => {
      state.loading = true;
    },
    [getHistoricalAttendance.fulfilled]: (state, action) => {
      state.loading = false;
      if (action.payload) {
        state.attendance.data = action.payload.searchStudentAttendance;
        state.attendance.totalNo = action.payload.totalNo;
      }
    },
    [getHistoricalAttendance.rejected]: (state) => {
      state.loading = false;
    },

    [getHistoricalMarks.pending]: (state) => {
      state.loading = true;
    },
    [getHistoricalMarks.fulfilled]: (state, action) => {
      state.loading = false;
      state.marks = action.payload;
    },
    [getHistoricalMarks.rejected]: (state) => {
      state.loading = false;
    },
  },
});

const { resetState, resetAttendance, resetMarks } = historicalSlice.actions;

export default historicalSlice.reducer;

export {
  resetState,
  resetAttendance,
  resetMarks,
  getHistoricalAttendance,
  getHistoricalMarks,
};
